import React, { useEffect, useState } from "react";
import "./ToggleButton.scss";
import rolesImage from "../assets/images/rolesImage.svg";
import OutsideClickHandler from "./OutsideClickHandler";
import { Link } from "react-router-dom";
import { formatDateUnrelatedTimezone } from "../utils/commonUtilities";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

const isTrue = (value) => value === "true" || value === true;
const ToggleButton = ({
  toggleLabel = "STATUS",
  onChangeCallback = () => {},
  toggleText = { on: "ON", off: "OFF" },
  defaultValue, // boolean
  customToggleStyle = false,
  statusUpdate,
  fromProvidersList = false,
  isReasonRequired = true,
}) => {
  const [isOn, setIsOn] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);
  const windowUrl = window.location.href;
  const practiceOrProvider = windowUrl.includes("practice") ? "practice" : "provider";

  useEffect(() => {
    setIsOn(defaultValue);
  }, [defaultValue]);

  return (
    <div className="toggle-container">
      <span className="toggleLabel"> {toggleLabel}:</span>
      <label className="toggle-switch">
        <input
          type="checkbox"
          checked={isOn}
          onChange={() => {
            setIsOn(!isOn);
            onChangeCallback(!isOn);
          }}
        />
        <span className={`slider ${customToggleStyle ? "custom" : ""}`}>
          <span className={`toggle-text ${isOn ? "on" : "off"}`}>
            {isOn ? toggleText.on : toggleText.off}
          </span>
        </span>
      </label>
      {isReasonRequired ? (
        <OutsideClickHandler
          onClickOutside={() => {
            if (showTooltip) {
              setShowTooltip(false);
            }
          }}
        >
          {!(statusUpdate?.isActive && statusUpdate?.isDisplayOnsite) ||
          statusUpdate?.accessPointStatus?.isDisplayedOnSite === "false" ? (
            <div className="tooltip-container">
              <img
                src={rolesImage}
                alt="Manager Role"
                className="tooltip-icon"
                onClick={() => setShowTooltip(!showTooltip)}
              />
              {showTooltip ? (
                fromProvidersList ? (
                  <div className="practice-popover-contect">
                    <div className="arrow"></div>
                    <div className={"tooltip-content show"}>
                      <dl className="dl-horizontal bottom-margin-zero">
                        {/* Access Point Status */}
                        <dt>Access Point Status:</dt>
                        <dd>
                          {isTrue(statusUpdate.accessPointStatus.isActive) &&
                            isTrue(
                              statusUpdate.accessPointStatus.isDisplayedOnSite
                            ) &&
                            isTrue(
                              statusUpdate.accessPointStatus.isDisplayInSearch
                            ) && <h4>Active</h4>}

                          {isTrue(statusUpdate.accessPointStatus.isActive) &&
                            isTrue(
                              statusUpdate.accessPointStatus.isDisplayedOnSite
                            ) &&
                            !isTrue(
                              statusUpdate.accessPointStatus.isDisplayInSearch
                            ) && <h4>ACTIVE - NAME SEARCH ONLY</h4>}

                          {isTrue(statusUpdate.accessPointStatus.isActive) &&
                            !isTrue(
                              statusUpdate.accessPointStatus.isDisplayedOnSite
                            ) && <h4>ACTIVE - NOT DISPLAYED ON SITE</h4>}

                          {!isTrue(statusUpdate.accessPointStatus.isActive) && (
                            <h4>INACTIVE</h4>
                          )}

                          {(!isTrue(statusUpdate.accessPointStatus.isActive) ||
                            !isTrue(
                              statusUpdate.accessPointStatus.isDisplayedOnSite
                            )) &&
                            statusUpdate.accessPointStatus.username != null && (
                              <p>
                                {statusUpdate.accessPointStatus.reason} (
                                {statusUpdate.accessPointStatus.note} -{" "}
                                {formatDate(
                                  statusUpdate.accessPointStatus.date
                                )}{" "}
                                by {statusUpdate.accessPointStatus.username})
                              </p>
                            )}
                        </dd>
                        {/* Provider Status */}
                        <dt>Provider Status:</dt>
                        <dd>
                          {isTrue(statusUpdate.providerStatus.isActive) &&
                            isTrue(
                              statusUpdate.providerStatus.isDisplayedOnSite
                            ) && <h4>Active</h4>}

                          {isTrue(statusUpdate.providerStatus.isActive) &&
                            !isTrue(
                              statusUpdate.providerStatus.isDisplayedOnSite
                            ) && <h4>ACTIVE - NOT DISPLAYED ON SITE</h4>}

                          {!isTrue(statusUpdate.providerStatus.isActive) && (
                            <h4>INACTIVE</h4>
                          )}

                          {(!isTrue(statusUpdate.providerStatus.isActive) ||
                            !isTrue(
                              statusUpdate.providerStatus.isDisplayedOnSite
                            )) &&
                            statusUpdate.providerStatus.username != null && (
                              <p>
                                ({statusUpdate.providerStatus.note} -{" "}
                                {formatDate(statusUpdate.providerStatus.date)}{" "}
                                by {statusUpdate.providerStatus.username})
                              </p>
                            )}
                        </dd>
                        {/* Practice Status */}
                        <dt>Practice Status:</dt>
                        <dd>
                          {isTrue(statusUpdate.practiceStatus.isActive) &&
                            isTrue(
                              statusUpdate.practiceStatus.isDisplayedOnSite
                            ) && <h4>Active</h4>}

                          {isTrue(statusUpdate.practiceStatus.isActive) &&
                            !isTrue(
                              statusUpdate.practiceStatus.isDisplayedOnSite
                            ) && <h4>ACTIVE - NOT DISPLAYED ON SITE</h4>}

                          {!isTrue(statusUpdate.practiceStatus.isActive) && (
                            <h4>INACTIVE</h4>
                          )}

                          {(!isTrue(statusUpdate.practiceStatus.isActive) ||
                            !isTrue(
                              statusUpdate.practiceStatus.isDisplayedOnSite
                            )) &&
                            statusUpdate.practiceStatus.username != null && (
                              <p>
                                ({statusUpdate.practiceStatus.note} -{" "}
                                {formatDate(statusUpdate.practiceStatus.date)}{" "}
                                by {statusUpdate.practiceStatus.username})
                              </p>
                            )}
                        </dd>
                      </dl>
                    </div>
                  </div>
                ) : (
                  <div className="practice-popover-contect">
                    <div className="arrow"></div>
                    <div className={"tooltip-content show"}>
                      <h4 className="popup-header">
                        {statusUpdate?.isActive === true &&
                        statusUpdate?.isDisplayOnsite === false
                          ? "ACTIVE - NOT DISPLAYED ON SITE"
                          : "INACTIVE "}
                        <span>
                          {statusUpdate?.isDisplayedOnSite === "false"
                            ? " - Not Displayed On Site"
                            : ""}
                          : {statusUpdate?.reason || statusUpdate?.reasonCode}
                        </span>
                        <span>
                          {statusUpdate?.duplicateOfEntityId === undefined ||
                          statusUpdate?.duplicateOfEntityId === null ||
                          statusUpdate?.duplicateOfEntityId === "" ? null : (
                            <Link
                              to={`/${practiceOrProvider}/${statusUpdate?.duplicateOfEntityId}/profile-information/info`}
                              className="duplicate-link"
                            >
                              ({statusUpdate?.duplicateOfEntityId})
                            </Link>
                          )}
                        </span>
                      </h4>
                      <p className="popup-notes">{statusUpdate?.note}</p>
                      <p className="popup-footer">
                        updated{" "}
                        {formatDateUnrelatedTimezone(
                          statusUpdate?.date?.split("T")[0]
                        )}{" "}
                        by {statusUpdate?.username}
                      </p>
                    </div>
                  </div>
                )
              ) : null}
            </div>
          ) : null}
        </OutsideClickHandler>
      ) : null}
    </div>
  );
};

export default ToggleButton;
